/* import __COLOCATED_TEMPLATE__ from './set-up-messenger-primary.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();